<template>
  <generic-modal
    size="tiny"
    :title="$t('teacher rating configuration')"
    icon="star"
    image="/images/icons/teacher_rating.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="field">
          <label for="">{{ $t("source organization tree") }}</label>
          <div class="ui search selection dropdown" ref="target_tree">
            <input type="hidden" name="target_tree" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      target_tree_id: "",
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/teacher_rating/configuration/do-save", {
          s: {
            target_tree_id: vm.target_tree_id,
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;

    /** Get trees */
    local_api(this, "post", "/teacher_rating/configuration/do-get-trees")
      .then((trees) => {
        let vls = trees.map((t) => {
          return { name: t.name, value: t.tree_id };
        });

        window
          .jQuery(vm.$refs.target_tree)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.target_tree_id = value;
            },
          });
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    local_api(this, "post", "/teacher_rating/configuration/do-get")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.target_tree_id) {
          console.log("setting selected", conf.setup.target_tree_id);
          window
            .jQuery(vm.$refs.target_tree)
            .dropdown("set selected", conf.setup.target_tree_id);
        }
        // if (conf && conf.setup && conf.setup.professions) {
        //   vm.$refs.professions.setList(conf.setup.professions);
        // }
        // if (conf && conf.setup && conf.setup.professional_colleges) {
        //   vm.$refs.professional_colleges.setList(
        //     conf.setup.professional_colleges,
        //   );
        // }
        // if (conf && conf.setup && conf.setup.tax_regimes) {
        //   vm.$refs.tax_regimes.setList(conf.setup.tax_regimes);
        // }
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
};
</script>
